import { Directive, OnDestroy } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { BaseClass } from './baseclass';

@UntilDestroy()
@Directive()
export class BaseService extends BaseClass implements OnDestroy {
  protected override isSubmitted = false;
  public isGlobal = false;

  override ngOnDestroy() {
    this.destroy();
  }
  destroy() {
    this.subscriptions.unsubscribe();
  }
}
